import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppInitializationService } from 'app/app-initialization.service';
import { Firmware } from 'app/models/firmware.model';
import { FirmwarePacket } from 'app/models/firmwarePacket.model';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable()
export class FirmwareService {

    firmware: any[];
    onChanged: BehaviorSubject<any>;

    constructor(
        private _httpClient: HttpClient,
        private appConfigService: AppInitializationService,
    ) {
        this.onChanged = new BehaviorSubject({});
    }

    resolve(): Observable<any> | Promise<any> | any {

        return new Promise<void>((resolve, reject) => {

            Promise.all([this.getFirmware()])
                .then(() => {
                    resolve()
                },
                    reject
                );
        });
    }


    getFirmware(): Promise<Array<Firmware>> {

        return new Promise((resolve, reject) => {
            this._httpClient.get(this.appConfigService.apiConfig["api-url"] + "firmwares")
                .subscribe((response: any) => {
                    this.firmware = response;
                    this.onChanged.next(this.firmware);
                    resolve(response);
                }, reject);
        });
    }

    getFirmwareCompany(companyId: number): Promise<Array<Firmware>> {

        return new Promise((resolve, reject) => {
            this._httpClient.get(this.appConfigService.apiConfig["api-url"] + "firmwares/" + companyId)
                .subscribe((response: any) => {
                    this.firmware = response;
                    this.onChanged.next(this.firmware);
                    resolve(response);
                }, reject);
        });
    }

    getFirmwarePacket(firmwareId: string): Promise<Array<FirmwarePacket>> {

        return new Promise((resolve, reject) => {
            this._httpClient.get(this.appConfigService.apiConfig["api-url"] + "firmwares/packets?firmwareId=" + firmwareId)
                .subscribe((response: any) => {
                    resolve(response);
                }, reject);
        });
    }

    add(entity: Firmware): Promise<Firmware> {

        return new Promise((resolve, reject) => {
            this._httpClient.post(this.appConfigService.apiConfig["api-url"] + "firmwares/add", entity)
                .subscribe((response: any) => {
                    resolve(response);
                }, reject);
        });
    }
    upload(entity: FormData): Promise<File> {

        return new Promise((resolve, reject) => {
            this._httpClient.post(this.appConfigService.apiConfig["api-url"] + "upload/firmware", entity)
                .subscribe((response: any) => {
                    resolve(response);
                }, reject);
        });
    }
    delete(firmware: Firmware): Promise<Firmware> {
        return new Promise((resolve, reject) => {
            this._httpClient.post(this.appConfigService.apiConfig["api-url"] + "firmwares/delete", firmware)
                .subscribe((response: any) => {
                    resolve(response);
                }, reject);
        });
    }
    fileDelete(entity: Firmware): Promise<Firmware> {
        return new Promise((resolve, reject) => {

            var form = new FormData()
            form.append('Position', 'firmware')
            form.append('Picture', entity['fileName'])
            this._httpClient.post(this.appConfigService.apiConfig["api-url"] + "upload/delete", form)
                .subscribe((response: any) => {
                    resolve(response);
                }, reject);
        })
    }
}
